<template>
    <div>
        <div>
            <div>
                <!-- <div class="row" >
                    <div class="col-md-6">
                        <base-input
                            type="text"
                            label="Sticker Printer Vendor ID"
                            v-model="menus.stickerPrinterVendorId"
                            />
                    </div>
                    <div class="col-md-6">
                        <base-input
                            type="text"
                            label="Sticker Printer Product ID"
                            v-model="menus.stickerPrinterProductId"
                            />
                    </div>
                      
                    
                </div> -->
                <div class="row">
                    <div class="col-md-6">
                        <base-input
                            type="text"
                            maxLength="255"
                            label="Printer Name"
                            v-model="menus.stickerPrinterName"
                            />
                    </div>
                     <div class="col-md-6">
                        <base-input
                            type="text"
                            maxLength="255"
                            label="Customer Feedback Message"
                            v-model="menus.stickerPrinterCustomerFeedbackMsg"
                            />
                    </div>
                </div>
                <div class="row">
                     <div class="col-md-6">
                        <base-input
                            type="text"
                            maxLength="255"
                            label="Custom Footer"
                            v-model="menus.stickerPrinterCustomFooter"
                            />
                    </div>
                     <div class="col-md-6">
                        <base-input
                            type="text"
                            maxLength="255"
                            label="QR Code Link"
                            v-model="menus.stickerPrinterQRCodeLink"
                            />
                    </div>
                </div>
                <div class="row">
                     <div class="col-md-6">
                           <base-checkbox class="mb-3" v-model="menus.enableItemCountDisplay" >Enable display of item count</base-checkbox>
                    </div>
                </div>
           
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

let component_x;
export default {
  computed: {...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'categoriesOptions']),},
  mounted: async function() {

        component_x = this;
        if(this.$attrs.defaultValue != undefined || this.$attrs.defaultValue != null){
            this.menus = this.$attrs.defaultValue
            this.isNewSetting = false
        }
        this.settingCode = this.$attrs.settingCode

  },

  data(){
    return{
        menus: {},
        stickerPrinterVendorId: null,
        stickerPrinterProductId: null,
        stickerPrinterName: null,
        stickerPrinterCustomerFeedbackMsg: null,
        stickerPrinterCustomFooter: null,
        stickerPrinterQRCodeLink: null,
        enableItemCountDisplay: false,
        settingCode: null,
    }
  },
  watch: {
    menus: {
        handler: async function(){
            this.stickerPrinterVendorId = this.menus.stickerPrinterVendorId
            this.stickerPrinterProductId = this.menus.stickerPrinterProductId
            this.stickerPrinterName = this.menus.stickerPrinterName
            this.stickerPrinterCustomerFeedbackMsg = this.menus.stickerPrinterCustomerFeedbackMsg
            this.stickerPrinterCustomFooter = this.menus.stickerPrinterCustomFooter
            this.stickerPrinterQRCodeLink = this.menus.stickerPrinterQRCodeLink
            this.enableItemCountDisplay = this.menus.enableItemCountDisplay
            var configValues = {}
            configValues[this.settingCode] = this.menus
            component_x.$emit("changeValue", configValues)
        },
        deep: true
    }
  },
    
}
</script>